import React from "react";
import { Menu } from "semantic-ui-react";
import DependencyTypeTab from "./DependencyTypeTab";
// import DependencySearchBar from "./DependencySearchBar";

/**
 * has DependencySearchBar and DependencyTypeTab.
 * kind like a Middle man and I started think this component is unneeded.
 */
function DependencyFilterMenu(props) {
  const {
    activeType,
    dependencyTypes,
    onTypeChange
    /** it causes layout colapse on smartphone, so commented out for now.
    query,
    onQueryChange,
    */
  } = props;

  return (
    <Menu tabular>
      {dependencyTypes.map(type => {
        console.log(type);
        return (
          <DependencyTypeTab
            key={type}
            type={type}
            active={activeType === type}
            onTypeChange={onTypeChange}
          />
        );
      })}
    </Menu>
  );
}

export default DependencyFilterMenu;



// WEBPACK FOOTER //
// ./src/components/DependencyFilterMenu.js